export const SDInputOverrides = error => ({
  Root: {
    style: ({ $theme }) => ({
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error ? 'transparent' : '',
      paddingRight: 0,
    }),
  },
  Input: {
    style: ({ $theme, $disabled }) => ({
      color: $theme.colors.black,
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      paddingBottom: '.125rem',
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error || $disabled ? 'transparent' : '',
    }),
  },
  InputContainer: {
    style: {
      paddingTop: '0.625rem',
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: () => ({
      paddingLeft: '2px',
      paddingRight: '1px',
      paddingBottom: '1px',
      paddingTop: '1px',
      backgroundColor: error ? 'transparent' : '',
    }),
  },
})
